import PropTypes from 'prop-types';

const StepItem = ({
  icon: Icon,
  title,
  description
}) => {
  return (
    <div className="flex gap-4 items-center group">
      <div className="flex-shrink-0">
        {typeof Icon === 'string' ? (
          <img src={Icon} alt="" className="w-[48px] h-[48px] object-contain" />
        ) : (
          <Icon size={32} strokeWidth={1.5} className="text-base-content" />
        )}
      </div>
      <div className="flex flex-col flex-1">
        <h3 className="font-bold text-[14px] leading-tight text-base-content mb-1">
          {title}
        </h3>
        <p className="text-base-content text-[14px] leading-snug">
          {description}
        </p>
      </div>
    </div>
  );
};

export default StepItem;

StepItem.propTypes = {
  icon: PropTypes.oneOfType([PropTypes.string, PropTypes.func, PropTypes.object]),
  title: PropTypes.string,
  description: PropTypes.string,
};
